module.exports = __webpack_public_path__ + "media/images/fast-and-easy-5ab98b802b3538a4b92177c45a8fd119.svg";